<script setup lang="ts">
import { computed } from 'vue';
import { Primitive, useForwardProps } from 'radix-vue';
import type { PinInputGroupProps } from '.';
import { cn } from '@/utils';

const props = defineProps<PinInputGroupProps>();
const delegatedProps = computed(() => {
	const { class: _, ...delegated } = props;
	return delegated;
});
const forwardedProps = useForwardProps(delegatedProps);
</script>

<template>
	<Primitive
		v-bind="forwardedProps"
		:class="cn('flex items-center gap-1', props.class)"
	>
		<slot></slot>
	</Primitive>
</template>
